export const skillsData = [
    'HTML',
    'CSS',
    'Javascript',
    'jQuery',
    'PHP',
    'Laravel',
    'Livewire',
    'Vue.js',
    'Node.js',
    'Express.js',
    'Nuxt.js',
    'Bootstrap',
    'Vuetify',
    'Tailwind CSS',
    'Socket',
    'Pinia',
    'Git',
    'GitHub',
    'GitLab',
    'Jira',
    'Slack',
    'Ubuntu',
    'MySQL',
    'SQLite',
    'MongoDB',
    'Firebase',
    'Odoo'
]